import { Stack, Accordion } from "@mantine/core";
import { useEffect, useRef, useState } from "react";
import { ExtendedFacetResult } from "../../../../types/UserDocument";
import { Categories, Fee, Languages } from "./filters/rate";
import { FilterKeys } from "./filters/filters";
import { useSearch } from "./SearchContext";

interface RenderFilterOptionsProps {
    facets?: { [key: string]: ExtendedFacetResult[] };
}


export const RenderFilterOptions = ({facets}: RenderFilterOptionsProps) => {

    const intialFacetRef = useRef(facets);
    const [value, setValue] = useState<string[]>(['fee']);
    const {
        searchExpression, 
    } = useSearch();


    useEffect(() => {
        if(!intialFacetRef.current) {
            intialFacetRef.current = facets;
        }
    }, [facets])

    useEffect(() => {
        intialFacetRef.current = undefined;;
    }, [searchExpression.searchText])



    return (
            <Stack>
                <Accordion chevronPosition="left" variant="separated" multiple onChange={setValue} value={value} >
                    <Fee />
                    <Languages  />
                    <Categories />
                </Accordion>
                </Stack>
    )
}